import Vue from 'vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { mustBeValidVouchercode } from '~utils/validators'

export default Vue.extend({
  mixins: [validationMixin],
  data(): {
    voucherCode: string;
  } {
    return {
      voucherCode: '',
    }
  },
  validations: {
    voucherCode: { required, mustBeValidVouchercode },
  },

  computed: {
    errors(): string[] {
      return this.$store.state.redemptions.errors
    },
    firstErrorKey(): string {
      return this.errors[0]
    },
    loading(): boolean {
      return this.$store.state.redemptions.loading
    },
    redemptionId(): string {
      return this.$route.query.redemption_id as string
    },
    sanitizedErrorParam(): string {
      if (!this.$route.query.error) {
        return ''
      }

      const errorParam = this.$route.query.error as string
      return this.$te(`errors.type.${errorParam}.title`) ? errorParam : 'general'
    },
    redemptionUltimateFailureReason(): string {
      return this.$store.state.redemptions.ultimateFailureReason
    },
  },

  async created() {
    if (this.sanitizedErrorParam) {
      this.$store.dispatch('redemptions/setErrors', {
        errors: [this.sanitizedErrorParam],
      })
    } else {
      this.$store.dispatch('redemptions/getRedemption', { redemptionId: this.redemptionId }).then(() => {
        if (this.$store.getters['redemptions/redemption'].appliedVouchers.length > 0) {
          this.$router.push({
            name: 'redemption-summary',
          })
        }
      })
    }
  },

  methods: {
    stripVoucherCodeOfSpecialChars() {
      this.voucherCode = this.voucherCode.replace(/-/g, '').replace(/ /g, '')
    },
    async onSubmit() {
      this.stripVoucherCodeOfSpecialChars()
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      await this.$store.dispatch('redemptions/updateRemption', {
        redemptionId: this.redemptionId,
        payload: this.buildPayload(),
      })

      if (this.errors.length === 0) {
        this.$router.push({
          name: 'redemption-summary',
        })
      }
    },
    buildPayload() {
      return {
        voucherCode: this.voucherCode,
      }
    },
  },
})
